import { runClientComponent } from '../../_common/client/client-component-runner';
import { ManufacturerContentComponent } from './manufacturer-content.component';

runClientComponent({ ManufacturerContentComponent });
